import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { PreEnrolledAccountsComponent } from './pre-enrolled-accounts.component';
import { AddPreInrolatComponent } from './add-pre-inrolat/add-pre-inrolat.component';
import { InfoPreInrolatComponent } from './info-pre-inrolat/info-pre-inrolat.component';
import { EditPreInrolatComponent } from './edit-pre-inrolat/edit-pre-inrolat.component';


@NgModule({
    declarations: [PreEnrolledAccountsComponent, AddPreInrolatComponent, InfoPreInrolatComponent, EditPreInrolatComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
    exports: [PreEnrolledAccountsComponent],
})
export class PreEnrolledAccountsModule { }
